export default parseInt(-((new Date()).getTimezoneOffset() / 60), 10);
